export default "__VITE_ASSET__DD7WU1qW__"